
export const LIST_GIFT = "LIST_GIFT";  
export const DETAIL_GIFT = "DETAIL_GIFT";  
export const CREATE_GIFT = "CREATE_GIFT";  
export const UPDATE_GIFT = "UPDATE_GIFT";
export const DELETE_GIFT = "DELETE_GIFT";